import classNames from 'classnames';
import { Link } from 'gatsby';
import React from 'react';

const PageTitle = ({ title, className = '' }: { title: string; className?: string }) => {
  const style = classNames('uppercase text-center font-header', {
    [className]: className,
  });
  return (
    <div className={style}>
      <Link to="/">{title}</Link>
    </div>
  );
};

export default PageTitle;
